import React from 'react';
import DynamicTable  from '../tables/DynamicTable';

interface Props {
    project: any;
    title: string;
}

const ExternalIDBox = ({ title, project } : Props) => {
    return (
        <div className="box">
            <h3>{title}</h3>
            <DynamicTable
            columns={[
                {id: 1 ,label: "Naam" ,property: "name"},
                {id: 2 ,label: "Type", property:'type'},
                {id: 3 ,label: "Systeem", property:'externalSystemId.name'},
                {id: 3 ,label: "Beschrijving", property:'description'},
                {id: 4 ,label: "Start Datum", property:'startDate'},
                {id: 5 ,label: "Eind Datum", property:'endDate'},
            ]}
            data={project?.externalIds?.models} 
            />
        </div>
    );
};

export default ExternalIDBox;
